import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Marketplace } from "@front/m19-api-client";
import { DASHBOARD_TYPE } from "@front/m19-injection-token";
import { AccountGroup } from "@front/m19-models";
import { AccountSelectionService } from "@front/m19-services";
import { IBadgeComponent, ISelectMenuImports } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { AccountGroupSelectorComponent } from "@m19-board/account-group-selector/account-group-selector.component";
import { MarketplaceSelectorComponent } from "@m19-board/marketplace-selector/marketplace-selector.component";
@Component({
  selector: "app-account-selector",
  templateUrl: "./account-selector.component.html",
  imports: [
    TranslocoDirective,
    AccountGroupSelectorComponent,
    ISelectMenuImports,
    MarketplaceSelectorComponent,
    IBadgeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSelectorComponent {
  private readonly accountSelectionService = inject(AccountSelectionService);
  public readonly scope = inject(DASHBOARD_TYPE);

  public isReadOnly = toSignal(this.accountSelectionService.readOnlyMode$, { requireSync: true });

  public readonly selectedMarketplacesMap = this.accountSelectionService.selectedMarketplacesMap;
  public readonly selectedAccountGroup = this.accountSelectionService.selectedAccountGroup;
  public readonly selectedMarketplace = this.accountSelectionService.selectedMarketplace;

  public readonly marketplaces = computed<Marketplace[]>(() => {
    return Array.from(this.selectedMarketplacesMap().keys());
  });

  selectGroup(accountGroup?: AccountGroup) {
    if (!accountGroup) return;

    const newAccountWithSameMarketplace = accountGroup
      .getAccountMarketplaces()
      .find((am) => am.marketplace === this.selectedMarketplace());
    const newAccount = newAccountWithSameMarketplace ?? accountGroup.getAccountMarketplaces()[0];

    this.accountSelectionService.selectAccountMarketplace([newAccount]);
  }

  selectMarketplace(marketplace: Marketplace | undefined) {
    if (!marketplace) return;
    const selectedAccountGroup = this.selectedAccountGroup();
    if (!selectedAccountGroup) return;
    this.accountSelectionService.selectAccountMarketplace(
      selectedAccountGroup.getAccountMarketplaces().filter((am) => am.marketplace === marketplace),
    );
  }
}
